// filters in the hero
document.addEventListener('DOMContentLoaded', function () {
  class HeroFilters extends HTMLElement {
    constructor() {
      super();
      // elements
      this.filterSelector = '.js-hero__filter';
      this.filterTriggerSelector = '.js-hero__filter-trigger';
      this.filterListSelector = '.js-hero__filter-list';
      this.filterCheckedSelector = '.js-hero__filter-checked';
    }
    connectedCallback() {
      // console.log('/scripts/hero-filters.js loaded');

      // bindings
      this.bndHandleClick = this.handleClick.bind(this);
      this.bndHandleChange = this.handleChange.bind(this);
      this.bndHandleKeydown = this.handleKeydown.bind(this);

      // events
      this.init();

      // - click
      document.addEventListener('click', this.bndHandleClick);
      document.addEventListener('keydown', this.bndHandleKeydown);
      this.addEventListener('change', this.bndHandleChange);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this.bndHandleClick);
      document.removeEventListener('keydown', this.bndHandleKeydown);
      document.removeEventListener('click', this.bndHandleChange);
    }
    init() {}
    handleChange(event) {
      const checkbox = event.target.closest('input[type="checkbox"]');
      if (!checkbox) return;
      const target = checkbox.closest(this.filterSelector);
      if (!target) return;
      const checks = target.querySelectorAll('input[type="checkbox"]');
      const texts = Array.from(checks).filter(check => check.checked).map(check => {
        return check?.closest('.c-input-checkbox')?.querySelector('.c-input-checkbox__label')?.textContent ?? null;
      }).filter(Boolean);
      if (texts) {
        target.querySelector(this.filterCheckedSelector).textContent = texts.join(', ');
      } else {
        target.querySelector(this.filterCheckedSelector).textContent = '';
      }
    }
    handleClick(event) {
      const filterTrigger = event.target.closest(this.filterTriggerSelector);
      const filter = event.target.closest(this.filterSelector);
      if (filterTrigger) {
        this.toggleFilter(filterTrigger, event);
      } else if (!filter) {
        this.closeAllFilters();
      }
    }
    closeAllFilters() {
      const filters = this.querySelectorAll(this.filterSelector);
      filters.forEach(filter => {
        filter.classList.remove('is-active');
        const list = filter.querySelector(this.filterListSelector);
        list.setAttribute('hidden', '');
      });
    }
    toggleFilter(trigger, event) {
      event.preventDefault();
      const target = trigger.getAttribute('data-target');
      if (!target) return;
      const targetElement = this.querySelector(`#${target}`);
      if (!targetElement) return;
      const open = !targetElement.hasAttribute('hidden');
      if (open) {
        trigger.closest(this.filterSelector).classList.remove('is-active');
        targetElement.setAttribute('hidden', '');
      } else {
        this.closeAllFilters();
        trigger.closest(this.filterSelector).classList.add('is-active');
        targetElement.removeAttribute('hidden');
      }
    }
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeAllFilters();
      }
    }
  }
  customElements.define('hero-filters', HeroFilters);
});